import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EDUCATION,
  DELETE_EDUCATION,
  UPDATE_EDUCATION,
  ADD_NEW_EDUCATION,
} from "./actionType";

import {
  getEducationSuccess,
  getEducationFail,
  deleteEducationSuccess,
  deleteEducationFail,
  updateEducationSuccess,
  updateEducationFail,
  addEducationSuccess,
  addEducationFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEducationApi,
  getEducationApi,
  updateEducationApi,
  deleteEducationApi,
  addNewEducationApi
} from "../../helpers/backend_helper";

function* getEducation({ payload: education }) {
  try {
    const response = yield call(getEducationApi, education);
    yield put(getEducationSuccess(GET_EDUCATION, response.data));
  } catch (error) {
    yield put(getEducationFail(GET_EDUCATION, error));
  }
}

function* onUpdateEducation({ payload: education }) {
  try {
    const response = yield call(updateEducationApi, education);
    yield put(updateEducationSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateEducationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEducation({ payload: education }) {
  try {
    const response = yield call(deleteEducationApi, education);
    yield put(deleteEducationSuccess({ education, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEducationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEducation({ payload: education }) {
  try {
    const response = yield call(addNewEducationApi, education);
    yield put(addEducationSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEducationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEducation() {
  yield takeEvery(GET_EDUCATION, getEducation);
}

export function* watchUpdateEducation() {
  yield takeEvery(UPDATE_EDUCATION, onUpdateEducation);
}

export function* watchDeleteEducation() {
  yield takeEvery(DELETE_EDUCATION, onDeleteEducation);
}

export function* watchAddNewEducation() {
  yield takeEvery(ADD_NEW_EDUCATION, onAddNewEducation);
}

function* educationSaga() {
  yield all([
    fork(watchGetEducation),
    fork(watchDeleteEducation),
    fork(watchUpdateEducation),
    fork(watchAddNewEducation)
  ]);
}

export default educationSaga;
